import PropTypes from 'prop-types';
import React, { useReducer } from 'react';
import ModalErrorProvider from '../components/ModalErrorProvider';
import FullScreenError from '../components/FullScreenError';
import { ErrorContext, ErrorDispatchContext } from '../context';
import { errorReducer } from '../reducers';
const ErrorProvider = ({ children, ModalErrorProviderProps = {
    withCloseButtonSingle: true
}, hideModalProvider })=>{
    const [errorState, dispatch] = useReducer(errorReducer, {
        errors: [],
        error: undefined,
        fullScreenError: undefined,
        isModalErrorVisible: false,
        isModalMultipleErrorsVisible: false
    });
    return /*#__PURE__*/ React.createElement(ErrorContext.Provider, {
        value: errorState
    }, /*#__PURE__*/ React.createElement(ErrorDispatchContext.Provider, {
        value: dispatch
    }, !hideModalProvider && /*#__PURE__*/ React.createElement(ModalErrorProvider, ModalErrorProviderProps), errorState.fullScreenError ? /*#__PURE__*/ React.createElement(FullScreenError, {
        error: errorState.fullScreenError
    }) : children));
};
ErrorProvider.propTypes = {
    ModalErrorProviderProps: PropTypes.object,
    children: PropTypes.node,
    hideModalProvider: PropTypes.bool
};
export default ErrorProvider;
